import { useMemo } from 'react';
import { Airport } from '../filters/useLocations';

export type MarkerMapType = Record<string, number>;

function makeMarkersMap<T extends Airport>(markers: T[] | undefined) {
  const markersMap: MarkerMapType = Object.create(null);
  if (markers) {
    for (let i = 0; i < markers.length; i++) {
      const marker = markers[i];
      markersMap[marker.value] = i;
    }
  }

  return {
    markersMap,
    has: (id: string) => markersMap[id] !== undefined,
    get: (id: string) => markersMap[id],
  };
}

function useIMCMarkersMap<T extends Airport>(markers: T[] | undefined) {
  return useMemo(() => makeMarkersMap(markers), [markers]);
}

export default useIMCMarkersMap;
